import { render, staticRenderFns } from "./needInvoice.vue?vue&type=template&id=853487b6&scoped=true&"
import script from "./needInvoice.vue?vue&type=script&lang=js&"
export * from "./needInvoice.vue?vue&type=script&lang=js&"
import style0 from "./needInvoice.vue?vue&type=style&index=0&id=853487b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853487b6",
  null
  
)

export default component.exports